var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './FileInput.module.scss';
import { useRef } from 'react';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import classNames from 'classnames';
import { FileCard } from 'src/ui/components/Input/FileInput/components/FileCard';
export var E_FILE_SIZE;
(function (E_FILE_SIZE) {
    E_FILE_SIZE[E_FILE_SIZE["ONE_KO"] = 1000] = "ONE_KO";
    E_FILE_SIZE[E_FILE_SIZE["ONE_MO"] = 1000000] = "ONE_MO";
    E_FILE_SIZE[E_FILE_SIZE["ONE_GO"] = 1000000000] = "ONE_GO";
})(E_FILE_SIZE || (E_FILE_SIZE = {}));
export var E_FILE_INPUT_ERROR;
(function (E_FILE_INPUT_ERROR) {
    E_FILE_INPUT_ERROR["FILE_TYPE"] = "FILE_TYPE";
    E_FILE_INPUT_ERROR["FILE_SIZE"] = "FILE_SIZE";
    E_FILE_INPUT_ERROR["LOADING_ERROR"] = "LOADING_ERROR";
})(E_FILE_INPUT_ERROR || (E_FILE_INPUT_ERROR = {}));
export var FileInput = function (props) {
    var _a;
    var file = props.file, typesAccepted = props.typesAccepted, placeholder = props.placeholder, limitSize = props.limitSize, isError = props.isError, withInfo = props.withInfo, infoMessage = props.infoMessage, onFileChange = props.onFileChange, onError = props.onError;
    var inputRef = useRef(null);
    var typesAcceptedJoined = Array.isArray(typesAccepted) ? typesAccepted.join(',') : typesAccepted;
    var handleFileDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var file = e.dataTransfer.files[0];
        if (file.type && !typesAcceptedJoined.includes(file.type)) {
            onError(E_FILE_INPUT_ERROR.FILE_TYPE, file);
            return;
        }
        if (limitSize && file.size > limitSize) {
            onError(E_FILE_INPUT_ERROR.FILE_SIZE, file);
            return;
        }
        onFileChange(file);
    };
    var handleDragOver = function (e) {
        e.preventDefault();
        e.stopPropagation();
    };
    var handleInputClick = function (e) {
        e.stopPropagation();
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    var handleFileSelected = function (e) {
        var file = e.target.files[0];
        onFileChange(file);
        // set nul to authorize the same file to be selected again
        inputRef.current.value = null;
    };
    var handleRemoveFile = function () {
        onFileChange(null);
    };
    var infoClassName = classNames(styles.infoMessage, (_a = {}, _a[styles.infoMessageError] = isError, _a));
    return (_jsxs("div", __assign({ className: styles.FileInputWrapper }, { children: [_jsxs("div", __assign({ className: styles.FileInput, onDrop: handleFileDrop, onDragOver: handleDragOver, onClick: handleInputClick }, { children: [_jsx("input", { ref: inputRef, type: "file", accept: typesAcceptedJoined, className: styles.FileInputElement, onChange: handleFileSelected }), placeholder] })), file ? (_jsx(FileCard, { type: file.type, name: file.name, size: file.size, onRemoveFile: handleRemoveFile })) : (withInfo && (_jsxs("div", __assign({ className: infoClassName }, { children: [infoMessage && _jsx(Icons, { className: styles.FileInputErrorIcon, icon: isError ? E_ICONS.WARNING : E_ICONS.INFO }), _jsx("p", __assign({ className: styles.FileInputErrorText }, { children: infoMessage }))] }))))] })));
};
